const menuBtn = document.querySelector(".el-site-header__menu-nav");
const overlay = document.querySelector(".el-site-header__overlay");
const drawer = document.querySelector(".el-site-header__drawer");
const closeBtn = document.querySelector(".el-site-header__menu-close");
const body = document.body;

menuBtn.onclick = openDrawer;
overlay.onclick = closeDrawer;
closeBtn.onclick = closeDrawer;

function openDrawer() {
  drawer.classList.add("open");
  overlay.classList.add("show");
  body.classList.add("no-scroll");
}

function closeDrawer() {
  drawer.classList.remove("open");
  overlay.classList.remove("show");
  body.classList.remove("no-scroll");
}

async function refreshHeaderCartCount() {
  try {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const cart = await fetch(root + "cart.js").then((response) => response.json());
    const count = Number(cart.item_count || 0);
    const cartIcon = document.querySelector("#cart-icon-bubble, .el-site-header__cart");

    document.querySelectorAll(".el-site-header__cart-count").forEach((el) => {
      el.remove();
    });

    if (count > 0 && cartIcon) {
      const badge = document.createElement("span");
      badge.className = "el-site-header__cart-count";
      badge.textContent = String(count);
      cartIcon.appendChild(badge);
    }
  } catch (error) {}
}

document.addEventListener("cart:updated", refreshHeaderCartCount);
window.refreshHeaderCartCount = refreshHeaderCartCount;

const header = document.querySelector('.el-site-header');
const headerHeight = header.offsetHeight;

window.addEventListener('scroll', () => {
  if (window.scrollY > 30) {
    header.classList.add('sticky');
    document.body.style.paddingTop = `${headerHeight}px`;
  } else {
    header.classList.remove('sticky');
    document.body.style.paddingTop = '';
  }
});